import { Grid, MenuItem, TextField } from "@mui/material";
import { FC, useContext, useEffect } from "react";
import ProjectsContext from "../../contexts/data/ProjectsContext";
import useStagesByProjectIds from "../../hooks/data/useStagesByProjectIds";

interface IStageMultiSelect {
    selectedProjectIds: number[],
    selectedStageIds: number[],
    setSelectedStageIds: React.Dispatch<React.SetStateAction<number[]>>,
}

const StageMultiSelect: FC<IStageMultiSelect> = ({
    selectedProjectIds,
    selectedStageIds,
    setSelectedStageIds
}) => {

    const {data: projects} = useContext(ProjectsContext);
    
    const {data: stages} = useStagesByProjectIds(selectedProjectIds);
    
    useEffect(() => {
        setSelectedStageIds(_old => selectedStageIds.filter(x => stages?.map(stage => stage.id).includes(x)))
    }, [stages])
    

    const handleStagesChange = (event: any) => {
        setSelectedStageIds(event.target.value);
    }

    return (
        <Grid
            size={{
                xs: 12
            }}
        >
            {
                selectedProjectIds.length > 0 && 
                <TextField
                    select
                    fullWidth
                    label="Stages"
                    value={selectedStageIds}
                    slotProps={{
                        select: {
                            multiple: true,
                            MenuProps: {
                                sx: {
                                    maxHeight: 500
                                }
                            }
                        }
                    }}
                    onChange={handleStagesChange}
                >
                    {
                        stages?.map(stage => 
                            <MenuItem key={stage.id} value={stage.id}>{projects?.filter(project => project.id == stage.projectId)[0].name } - {stage.name}</MenuItem>
                        )
                    }
                </TextField>
            }
        </Grid>
    );
}

export default StageMultiSelect;